// 需走登录逻辑的页面
export const basicPortalRouter = [
  {
    path: 'demo',
    name: 'feature-portal-demo',
    meta: { title: 'feature-portal demo' },
    component: () => import('./views/demo/index.vue'),
  },
];

// 不需走登录逻辑的静态提示页
export const staticPortalRouter = [
  {
    path: 'noAccountPermission',
    name: 'feature-portal-no-account-permission',
    meta: { title: '提示', description: '无账号权限' },
    component: () => import('./views/no-account-permission/index.vue'),
  },
  {
    path: 'static/informationAuthorizationGuide',
    name: 'feature-portal-information-authorization-guide',
    meta: { title: '个人信息授权' },
    component: () => import('./views/information-authorization-guide/index.vue'),
  },
];
